import Vue from 'vue'
import Router from 'vue-router'
import util from "@/common/util.js";
const Home = () => import("@/pages/Home")
const Dashboard = () => import("@/pages/Dashboard")
const schoolDashboard = () => import("@/pages/schoolDashboard")
const notFound = () => import("@/pages/error-page/404")
const notPermission = () => import("@/pages/error-page/401")
const PotentialCheckTable = () => import("@/pages/Potential/check-table/list")
const PotentialCheckPlan = () => import("@/pages/Potential/check-plan/list")
const PotentialExaminationPre = () => import("@/pages/Potential/potential-exam/list")
const PotentialAssignmentPre = () => import("@/pages/Potential/potential-lssue/list")
const PotentialApplyCancelPre = () => import("@/pages/Potential/potential-cancel/list")

const PotentialRectificationPre = () => import("@/pages/Potential/potential-reform/list")
const PotentialFilePre = () => import("@/pages/Potential/potential-file/list")
const potentialCheckRecord = () => import("@/pages/Potential/check-record/list")
const RegulatorPotentialTask = () => import("@/pages/Potential/RegulatorPotentialTask/list")
const RegulatorSafetyMeetingTask = () => import("@/pages/Meeting/RegulatorSafetyMeetingTask/list")
const RegulatorWorkTask = () => import("@/pages/System/RegulatorWorkTask")
//消息提醒设置
const Sms = () => import("@/pages/Sms/sms")
//预过期设置
const PreExpirationConfig = () => import("@/pages/PreExpirationConfig/PreExpirationConfig")
//积分
const Integralset = () => import("@/pages/Integral/Integralset")
const Integralist = () => import("@/pages/Integral/Integralist")
// 一企一档
const organList = () => import("@/pages/Enterprises/organList")
const postList = () => import("@/pages/Enterprises/postList")
//企业基本信息
const EnterpriseInfo = () => import("@/pages/Enterprises/EnterpriseInfo")
const EnterpriseData = () => import("@/pages/Enterprises/EnterpriseData")
const ServiceUnit = () => import("@/pages/Enterprises/ServiceUnit")
const SchoolVehicle = () => import("@/pages/Enterprises/SchoolVehicle")
const SchoolVehicleInsurance = () => import("@/pages/Enterprises/SchoolVehicleInsurance")
const SchoolVideoMonitor = () => import("@/pages/Enterprises/SchoolVideoMonitor")
const SchoolVehicleRepairRecord = () => import("@/pages/Enterprises/SchoolVehicleRepairRecord")
//人员
const UserRewardsPunishmentRecord = () => import("@/pages/Enterprises/UserRewardsPunishmentRecord")
const UserHomeVisitRecord = () => import("@/pages/Enterprises/UserHomeVisitRecord")
//驾驶员档案
const Driver = () => import("@/pages/Enterprises/Driver")
//装卸人员档案
const Stevedore = () => import("@/pages/Enterprises/Stevedore")
//押运员档案
const Escort = () => import("@/pages/Enterprises/Escort")
//应急管理
//const Emergency = () => import("@/pages/Enterprises/Emergency")
//安全投入
const SafetyInput = () => import("@/pages/Enterprises/SafetyInput")
//安全管理 相关安全负责人
const SafetyPerson = () => import("@/pages/Enterprises/SafetyPerson")
//安全管理 专职监控人员
const MonitorPerson = () => import("@/pages/Enterprises/MonitorPerson")
//安全管理 安全生产管理网络图
const NetworkDocumen = () => import("@/pages/Enterprises/NetworkDocumen")
//车辆管理
const Vehicle = () => import("@/pages/Enterprises/Vehicle")
//安全例会
const SafetyMeeting = () => import("@/pages/Enterprises/SafetyMeeting")
//安全培训
const SafetyTrained = () => import("@/pages/Enterprises/SafetyTrained")
//事故信息
const Accident = () => import("@/pages/Enterprises/Accident")
//特种设备作业人员
const SpecialPersonnel = () => import("@/pages/Enterprises/SpecialPersonnel")
//特种设备
const SpecialEquipment = () => import("@/pages/Enterprises/SpecialEquipment")
//用户
const User = () => import("@/pages/Enterprises/User")
//文件签字管理
const FileSign = () => import("@/pages/FileSign/list")
//班前会
const PreMeetingSign = () => import("@/pages/Enterprises/PreMeetingSign")
//体系运行
//体系文件
const Document = () => import("@/pages/Documents/Document")
//风险管控
//风险单元
const RiskUnit = () => import("@/pages/RiskManagement/RiskUnit")
//事故类型
const RiskEvent = () => import("@/pages/RiskManagement/RiskEvent")
//风险分级管控
const RiskControl = () => import("@/pages/RiskManagement/RiskControl")
//风险单元巡查
const Inspection = () => import("@/pages/RiskManagement/Inspection")
//系统管理
//通知公告
const Notices = () => import("@/pages/System/Notices")
//待办事项
const Mail = () => import("@/pages/System/Mail")
//修改密码
const Password = () => import("@/pages/System/Password")
//用户信息
const UserInfo = () => import("@/pages/System/UserInfo")
//违章管理
const violationList = () => import("@/pages/Violations/violationList")
//学习园地
const accidentcases = () => import("@/pages/Study/accidentcases")
const Study = () => import("@/pages/Study/study")
const technicalnorm = () => import("@/pages/Study/technicalnorm")
const law = () => import("@/pages/Study/law")
//附件信息
//const Attachment = () => import("@/pages/Public/Attachment")
//应急管理
const reservePlan = () => import("@/pages/Emergency/reservePlan")
const troops = () => import("@/pages/Emergency/troops")
const material = () => import("@/pages/Emergency/material")
const drill = () => import("@/pages/Emergency/drill")

//安全例会
const MeetTable = () => import("@/pages/Meeting/MeetTable")
const potentialCheck = () => import("@/pages/Potential/potential-check/list")

const potentialReview = () => import("@/pages/potential/potential-review/list")
const potentialRecord = () => import("@/pages/Potential/potential-record/list")
const potentialDangerRecord = () => import("@/pages/Potential/potential-danger-record/list")
const Logbook = () => import("@/pages/Logbook/list")
const MonthSafelyCheck = () => import("@/pages/MonthSafelyCheck/list")
const Assess = () => import("@/pages/Assess/list")
const VehicleWarn = () => import("@/pages/VehicleWarn/VehicleWarn")
const VehicleLocation = () => import("@/pages/VehicleLocation/VehicleLocation")

//教育培训
const Questions = () => import("@/pages/Education/Questions")
const Paper = () => import("@/pages/Education/Paper")
const Courseware = () => import("@/pages/Education/Courseware")
const Course = () => import("@/pages/Education/Course")
const Train = () => import("@/pages/Education/Train")
const Traintask = () => import("@/pages/Education/Traintask")
const TrainTaskDetail = () => import("@/pages/Education/TrainTaskDetail")
const RegulatorTrainTask = () => import("@/pages/Education/RegulatorTrainTask")

//培训管理
const safetyTrainingProgramList = () => import("@/pages/trainingManagement/safetyTrainingProgramList")
const trainingTask = () => import("@/pages/trainingManagement/trainingTask")
const latojaManagement = () => import("@/pages/trainingManagement/latojaManagement")
//学员端
const myExam = () => import("@/pages/student/myExam")
const myTrain = () => import("@/pages/student/myTrain")
//一企一档
const ent = () => import("@/pages/archives/ent")
// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(['@/pages/Login'], resolve)
const SafeSourceLogin = resolve => require(['@/pages/customLogin/safeSourceLogin'], resolve); // 安全源定制登录页
const schoolLogin = resolve => require(['@/pages/schoolLogin'], resolve)
//工作计划
const workplanTable = () => import("@/pages/Workplan/workplanTable")
//统计报表
const WorkStatistics = () => import("@/pages/Statistics/WorkStatistics")
const UserStatistics = () => import("@/pages/Statistics/UserStatistics")
const VehicleStatistics = () => import("@/pages/Statistics/VehicleStatistics")
const RiskStatistics = () => import("@/pages/Statistics/RiskStatistics")
const PotentialStatistics = () => import("@/pages/Statistics/PotentialStatistics")
const AccidentStatistics = () => import("@/pages/Statistics/AccidentStatistics")
const SafetyMeetingStatistics = () => import("@/pages/Statistics/SafetyMeetingStatistics")
const VehicleViolationStatistics = () => import("@/pages/Statistics/VehicleViolationStatistics")
const LogbookWeekStatictis = () => import("@/pages/Statistics/LogbookWeekStatictis")
const LogbookMonthStatictis = () => import("@/pages/Statistics/LogbookMonthStatictis")

//企业自定义文件上传
const EnterpriseUploadFile = () => import("@/pages/ManageFile/EnterpriseUploadFile")
const EnterpriseUploadDetailFile = () => import("@/pages/ManageFile/EnterpriseUploadDetailFile")

//线路
const DrivingLine = () => import("@/pages/DrivingLine/list")
const AddDrivingLine = () => import("@/pages/DrivingLine/AddDrivingLine")

//费用支出
const FinancePayCategory = () => import("@/pages/FinancePay/FinancePayCategory")
const FinancePayDetail = () => import("@/pages/FinancePay/FinancePayDetail")
const FinancePayDetailMonthStatistics = () => import("@/pages/FinancePay/FinancePayDetailMonthStatistics")
const FinancePayDetailYearStatistics = () => import("@/pages/FinancePay/FinancePayDetailYearStatistics")
const FinanceBalanceMonth = () => import("@/pages/FinancePay/FinanceBalanceMonth")
const FinanceBalanceYear = () => import("@/pages/FinancePay/FinanceBalanceYear")

// 社会监督
const SocialSupervision = () => import("@/pages/Enterprises/SocialSupervision");
// 生产事故
const productionAccident = () => import('@/pages/productionAccident');
// 相关方事故
const relatedPartyAccidents = () => import('@/pages/relatedPartyAccidents');

// 安全生产费用
const safetyProductionCost = () => import('@/pages/safetyProductionCost');
// 健康档案
const healthRecords = () => import('@/pages/healthRecords');
// 职业病危害
const occupationalDiseaseHazards = () => import('@/pages/occupationalDiseaseHazards');
// 通知公告
const noticeAnnouncement = () => import('@/pages/noticeAnnouncement/list');
// 违法违章
const violationRecord = () => import('@/pages/violationRecord');

// 行车日志参数配置
const LogBookConfig = () => import('@/pages/CheckConfiguration/LogBookConfig/list');
//执行检查参数配置
const PerformInspectionConfig = () => import('@/pages/CheckConfiguration/PerformInspectionConfig/list');
//月度安全检查检查项配置
const MonthlySafetyInspection  = () => import('@/pages/CheckConfiguration/MonthlySafetyInspection/list');

Vue.use(Router)
let router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/schoolLogin',
      name: '登录',
      component: schoolLogin
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/safeSourceLogin',
      name: '安全源登录', // 安全源定制登录页
      component: SafeSourceLogin
    },
    {
      path: '/404',
      name: 'notFound',
      component: notFound,
    },
    {
      path: '/401',
      name: 'notPermission',
      component: notPermission,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/dashboard',
      leaf: true, // 只有一个节点
      menuShow: true,
      iconCls: 'fa fa-home', // 图标样式class
      children: [
        { path: '/dashboard', component: Dashboard, name: '首页', menuShow: true },
      ]
    },
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home,
    //   redirect: '/schoolDashboard',
    //   leaf: true, // 只有一个节点
    //   menuShow: true,
    //   iconCls: 'fa fa-home', // 图标样式class
    //   children: [
    //     { path: '/schoolDashboard', component: schoolDashboard, name: '首页', menuShow: true },
    //   ]
    // },
    {
      path: '/',
      component: Home,
      name: '事故隐患',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/potential-check-table', component: PotentialCheckTable, name: '检查表管理', menuShow: true },
        { path: '/potential-check-plan', component: PotentialCheckPlan, name: '检查计划', menuShow: true },
        { path: '/potential-check', component: potentialCheck, name: '隐患检查', menuShow: true },
        { path: '/PotentialRectificationPre', component: PotentialRectificationPre, name: ' 隐患整改', menuShow: true },
        { path: '/PotentialReexaminePre', component: potentialReview, name: '隐患复查', menuShow: true },
        { path: '/potential-record', component: potentialRecord, name: '隐患记录', menuShow: true },
        { path: '/potential-danger-record', component: potentialDangerRecord, name: '排查隐患记录', menuShow: true },
        { path: '/PotentialExaminationPre', component: PotentialExaminationPre, name: '隐患审核', menuShow: true },
        { path: '/PotentialAssignmentPre', component: PotentialAssignmentPre, name: '隐患下发', menuShow: true },
        { path: '/PotentialApplyCancelPre', component: PotentialApplyCancelPre, name: '隐患销号', menuShow: true },
        { path: '/PotentialFilePre', component: PotentialFilePre, name: '隐患归档', menuShow: true },
        { path: '/potential-check-record', component: potentialCheckRecord, name: '检查记录', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '积分管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Integralset', component: Integralset, name: '积分设置', menuShow: true },
        { path: '/Integralist', component: Integralist, name: '积分列表', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '日志管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Logbook', component: Logbook, name: '行车日志', menuShow: true },
        { path: '/MonthSafelyCheck', component: MonthSafelyCheck, name: '月度安全检查', menuShow: true },
        { path: '/Assess', component: Assess, name: '心理评测', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '安全例会管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/MeetTable', component: MeetTable, name: '安全例会', menuShow: true },
      ]
    },

    {
      path: '/',
      component: Home,
      name: '动态监管',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/VehicleLocation', component: VehicleLocation, name: '车辆定位信息', menuShow: true },
        { path: '/VehicleWarn', component: VehicleWarn, name: '车辆报警信息', menuShow: true },
        { path: '/violationList', component: violationList, name: '车辆违章记录', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '应急管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/reservePlan', component: reservePlan, name: '应急预案', menuShow: true },
        { path: '/troops', component: troops, name: '应急队伍', menuShow: true },
        { path: '/material', component: material, name: '应急物质', menuShow: true },
        { path: '/drill', component: drill, name: '应急演练', menuShow: true },
      ]
    },

    {
      path: '/',
      component: Home,
      name: '学习园地管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Study', component: Study, name: '学习园地', menuShow: true },
        { path: '/technicalnorm', component: technicalnorm, name: '技术规范', menuShow: true },
        { path: '/law', component: law, name: '法律法规', menuShow: true },
        { path: '/accidentcases', component: accidentcases, name: '典型事故案例', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '企业管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/EnterpriseInfo', component: EnterpriseInfo, name: '企业信息', menuShow: true },
        { path: '/EnterpriseData', component: EnterpriseData, name: '企业信息', menuShow: true },
        { path: '/ServiceUnit', component: ServiceUnit, name: '服务单位', menuShow: true },
        { path: '/SchoolVehicle', component: SchoolVehicle, name: '车辆档案', menuShow: true },
        { path: '/SchoolVehicleInsurance', component: SchoolVehicleInsurance, name: '车辆保险', menuShow: true },
        { path: '/SchoolVideoMonitor', component: SchoolVideoMonitor, name: '视频监控', menuShow: true },
        { path: '/SchoolVehicleRepairRecord', component: SchoolVehicleRepairRecord, name: '维修记录', menuShow: true },
        { path: '/Driver', component: Driver, name: '驾驶员档案', menuShow: true },
        { path: '/SafetyPerson', component: SafetyPerson, name: '安全管理 相关安全负责人', menuShow: true },
        { path: '/MonitorPerson', component: MonitorPerson, name: '安全管理 专职监控人员', menuShow: true },
        { path: '/NetworkDocumen', component: NetworkDocumen, name: '安全管理 安全生产管理网络图', menuShow: true },
        { path: '/Escort', component: Escort, name: '押运员档案', menuShow: true },
        { path: '/Stevedore', component: Stevedore, name: '装卸人员档案', menuShow: true },
        { path: '/SafetyInput', component: SafetyInput, name: '安全投入', menuShow: true },
        { path: '/Vehicle', component: Vehicle, name: '车辆档案', menuShow: true },
        { path: '/SafetyMeeting', component: SafetyMeeting, name: '安全例会Old', menuShow: true },
        { path: '/SafetyTrained', component: SafetyTrained, name: '安全培训', menuShow: true },
        { path: '/Accident', component: Accident, name: '事故信息', menuShow: true },
        { path: '/SpecialPersonnel', component: SpecialPersonnel, name: '特种设备作业人员', menuShow: true },
        { path: '/SpecialEquipment', component: SpecialEquipment, name: '特种设备', menuShow: true },
        { path: '/User', component: User, name: '用户管理', menuShow: true },
        { path: '/organList', component: organList, name: '部门管理', menuShow: true },
        { path: '/postList', component: postList, name: '岗位管理', menuShow: true },
        { path: '/archives/ent', component: ent, name: '一企一档', menuShow: true },
        { path: '/FileSign', component: FileSign, name: '文件签字管理', menuShow: true },
        { path: '/PreMeetingSign', component: PreMeetingSign, name: '班前会', menuShow: true },
        { path: '/UserRewardsPunishmentRecord', component: UserRewardsPunishmentRecord, name: '奖惩记录', menuShow: true },
        { path: '/UserHomeVisitRecord', component: UserHomeVisitRecord, name: '家访记录', menuShow: true },
        { path: '/SocialSupervision', component: SocialSupervision, name: '社会监督', menuShow: true },
        { path: '/productionAccident', component: productionAccident, name: '生产事故', menuShow: true },
        { path: '/relatedPartyAccidents', component: relatedPartyAccidents, name: '相关方事故', menuShow: true },
        // {path: '/Test', component: Test, name: 'Test', menuShow: true},
        { path: '/safetyProductionCost', component: safetyProductionCost, name: '安全生产费用', menuShow: true },
        { path: '/healthRecords', component: healthRecords, name: '健康档案', menuShow: true },
        { path: '/occupationalDiseaseHazards', component: occupationalDiseaseHazards, name: '职业病危害', menuShow: true },
        { path: '/violationRecord', component: violationRecord, name: '违法违章', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '体系运行',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Document', component: Document, name: '体系文件', menuShow: true },
      ]
    },

    {
      path: '/',
      component: Home,
      name: '风险管控',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/RiskUnit', component: RiskUnit, name: '风险单元', menuShow: true },
        { path: '/RiskEvent', component: RiskEvent, name: '事故类型', menuShow: true },
        { path: '/RiskControl', component: RiskControl, name: '风险分级管控', menuShow: true },
        { path: '/Inspection', component: Inspection, name: '风险单元巡查', menuShow: true }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '系统管理',
      menuShow: true,
      leaf: true,
      children: [

        { path: '/Mail', component: Mail, name: '待办事项', menuShow: true },
        { path: '/RegulatorWorkTask', component: RegulatorWorkTask, name: '工作任务', menuShow: true },
        { path: '/RegulatorTrainTask', component: RegulatorTrainTask, name: '培训任务', menuShow: true },
        { path: '/RegulatorPotentialTask', component: RegulatorPotentialTask, name: '隐患排查任务', menuShow: true },
        { path: '/RegulatorSafetyMeetingTask', component: RegulatorSafetyMeetingTask, name: '安全例会任务', menuShow: true },
        { path: '/Password', component: Password, name: '修改密码', menuShow: true },
        { path: '/UserInfo', component: UserInfo, name: '用户信息', menuShow: true },
        { path: '/noticeAnnouncement', component: noticeAnnouncement, name: '通知公告', menuShow: true },
      ]
    },

    {
      path: '/',
      component: Home,
      name: '工作计划管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/workplanTable', component: workplanTable, name: '工作计划', menuShow: true },
      ]
    },

    {
      path: '/',
      component: Home,
      name: '参数配置',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Sms', component: Sms, name: '短信推送', menuShow: true },
        { path: '/PreExpirationConfig', component: PreExpirationConfig, name: '预过期时间配置', menuShow: true },
		{ path: '/LogBookConfig', component: LogBookConfig, name: '行车日志参数配置', menuShow: true },
		{ path: '/PerformInspectionConfig', component: PerformInspectionConfig, name: '执行检查参数配置', menuShow: true },
		{ path: '/MonthlySafetyInspection', component: MonthlySafetyInspection, name: '月度安全检查参数配置', menuShow: true },
		
      ]
    },

    {
      path: '/',
      component: Home,
      name: '教育培训',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/Questions', component: Questions, name: '试题管理', menuShow: true },
        { path: '/Paper', component: Paper, name: '试卷管理', menuShow: true },
        { path: '/Courseware', component: Courseware, name: '课件管理', menuShow: true },
        { path: '/Course', component: Course, name: '课程管理', menuShow: true },
        { path: '/Train', component: Train, name: '培训计划', menuShow: true },
        { path: '/Traintask', component: Traintask, name: '培训任务', menuShow: true },
        { path: '/TrainTaskDetail', component: TrainTaskDetail, name: '培训任务详情', menuShow: true },
      ]

    },

    {
      path: '/',
      component: Home,
      name: '培训管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/trainingManagement/safetyTrainingProgramList', component: safetyTrainingProgramList, name: '安全培训计划', menuShow: true },
        { path: '/trainingManagement/trainingTask', component: trainingTask, name: '培训任务实施', menuShow: true },
        { path: '/trainingManagement/latojaManagement', component: latojaManagement, name: '线下培训管理', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '学员端',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/student/myExam', component: myExam, name: '我的考试', menuShow: true },
        { path: '/student/myTrain', component: myTrain, name: '我的培训', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '统计报表',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/WorkStatistics', component: WorkStatistics, name: '工作情况统计表', menuShow: true },
        { path: '/UserStatistics', component: UserStatistics, name: '人员统计', menuShow: true },
        { path: '/VehicleStatistics', component: VehicleStatistics, name: '车辆统计', menuShow: true },
        { path: '/RiskStatistics', component: RiskStatistics, name: '风险统计', menuShow: true },
        { path: '/PotentialStatistics', component: PotentialStatistics, name: '隐患统计', menuShow: true },
        { path: '/AccidentStatistics', component: AccidentStatistics, name: '事故统计', menuShow: true },
        { path: '/SafetyMeetingStatistics', component: SafetyMeetingStatistics, name: '安全例会统计', menuShow: true },
        { path: '/VehicleViolationStatistics', component: VehicleViolationStatistics, name: '车辆违章统计', menuShow: true },
        { path: '/LogbookWeekStatictis', component: LogbookWeekStatictis, name: '行车日志周统计', menuShow: true },
        { path: '/LogbookMonthStatictis', component: LogbookMonthStatictis, name: '行车日志月统计', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '车辆线路',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/DrivingLine', component: DrivingLine, name: '路线管理', menuShow: true },
        { path: '/AddDrivingLine', component: AddDrivingLine, name: '添加路线', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '文件管理',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/EnterpriseUploadFile', component: EnterpriseUploadFile, name: '企业上传文件', menuShow: true },
        { path: '/EnterpriseUploadDetailFile', component: EnterpriseUploadDetailFile, name: '企业上传详细文件', menuShow: true },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '费用支出',
      menuShow: true,
      leaf: true,
      children: [
        { path: '/FinancePayCategory', component: FinancePayCategory, name: '费用支出项设置', menuShow: true },
        { path: '/FinancePayDetail', component: FinancePayDetail, name: '费用支出明细', menuShow: true },
        { path: '/FinancePayDetailMonthStatistics', component: FinancePayDetailMonthStatistics, name: '费用支出月度台账', menuShow: true },
        { path: '/FinancePayDetailYearStatistics', component: FinancePayDetailYearStatistics, name: '费用支出年度台账', menuShow: true },
        { path: '/FinanceBalanceMonth', component: FinanceBalanceMonth, name: '费用月度结余', menuShow: true },
        { path: '/FinanceBalanceYear', component: FinanceBalanceYear, name: '费用年度结余', menuShow: true },
      ]
    },
    // 404 page must be placed at the end !!!
    {
      path: "*",
      redirect: "/404"
    }

  ]
})
let loginUrl = util.getLoginUrl();
router.beforeEach((to, from, next) => {
  if (to.path.startsWith(loginUrl)) {
    window.localStorage.removeItem('userinfo')
    next()
  } else if (to.path.startsWith('/404')) {
    next()
  } else if (to.path.includes('http')) {
    window.open(to.fullPath.substr(1));
  } else {
    let user = window.localStorage.getItem('userinfo');
    if (!user) {
      next({ path: loginUrl})
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js